/**
 * Salvation Services Module
 * Exports all Salvation Management services and the factory function.
 * Backend: CCMS.Api.SalvationManagement (servicePath `salvation`, gateway prefix `/salvation/`).
 */
import { SalvationLookupsService } from './SalvationLookupsService';
import { SalvationMeService } from './SalvationMeService';
import { SalvationAdminService } from './SalvationAdminService';
export { SalvationLookupsService, SalvationMeService, SalvationAdminService };
/**
 * Create all Salvation Management services with shared configuration.
 */
export function createSalvationServices(http, config) {
    return {
        salvationLookups: new SalvationLookupsService(http, config),
        salvationMe: new SalvationMeService(http, config),
        salvationAdmin: new SalvationAdminService(http, config),
    };
}
//# sourceMappingURL=index.js.map